<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Images Manager</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-2">
  <div class="d-flex flex-column gap-3 p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Bulk Upload</h5>
        <p class="card-text text-muted">
          Upload multiple images using the format: barcode.orientation.extension
          <br />
          Example: 123456789.1.jpg (1=front, 2=side, 3=flatpack)
          <br />
          For a tray/case image, suffix the barcode with T or C: 123456789T.1.jpg (tray), 123456789C.1.jpg (case)
        </p>
        <input
          type="file"
          class="form-control"
          multiple
          accept="image/*"
          (change)="handleBulkUpload($event)"
        />
        @if (uploads.length > 0) {
        <div class="table-responsive mt-2" style="max-height: 200px">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Preview</th>
                <th>Barcode</th>
                <th>Orientation</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (upload of uploads; track upload; let i = $index) {
              <tr>
                <td>
                  <img
                    [src]="upload.preview"
                    class="img-thumbnail"
                    style="max-height: 50px"
                  />
                </td>
                <td>{{ upload.barcode }}</td>
                <td>{{ orientations[upload.orientation] }}</td>
                <td>
                  @if (upload.error) {
                  <span class="text-danger" [title]="upload.error">{{ upload.error }}</span>
                  } @else if (upload.uploaded && !upload.error) {
                  <span class="text-success">
                    <i class="bi bi-check-circle"></i> {{ upload.message || "Uploaded" }}
                  </span>
                  } @else {
                  <span class="text-muted">Pending</span>
                  }
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    (click)="removeUpload(i)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="mt-2 small text-muted">
          Total: <strong>{{ totalFiles }}</strong> |
          Uploaded: <span class="text-success">{{ uploadedCount }}</span> |
          Failed: <span class="text-danger">{{ failedCount }}</span> |
          Pending: <span class="text-secondary">{{ pendingCount }}</span>
          @if (processing) {
            <span class="ms-2">
              <span class="spinner-border spinner-border-sm"></span> Processing...
            </span>
          }
        </div>
        }
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-body">
        <h5 class="card-title">Download Original Image</h5>
        <p class="card-text text-muted">
          Enter a barcode and orientation to download the original product
          image.
        </p>
        <div class="row g-2">
          <div class="col">
            <input
              type="text"
              class="form-control"
              placeholder="Barcode"
              [(ngModel)]="downloadBarcode"
            />
          </div>
          <div class="col">
            <select class="form-select" [(ngModel)]="downloadOrientation">
              <option
                *ngFor="let o of orientations | keyvalue"
                [value]="o.value"
              >
                {{ o.key }}
              </option>
            </select>
          </div>
          <div class="col-auto">
            <button
              class="btn btn-outline-primary"
              (click)="downloadImage()"
              [disabled]="!downloadBarcode"
            >
              <i class="bi bi-download"></i> Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="form-check me-3">
    <input
      type="checkbox"
      class="form-check-input"
      id="replaceIfExists"
      [(ngModel)]="replaceIfExists"
    />
    <label class="form-check-label" for="replaceIfExists">
      Replace if exists
    </label>
  </div>
  
  <div class="form-check me-auto">
    <input
      type="checkbox"
      class="form-check-input"
      id="skipProcessing"
      [(ngModel)]="skipBackgroundRemoval"
    />
    <label class="form-check-label" for="skipProcessing">
      Skip background removal
    </label>
  </div>

  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="uploads.length === 0 || processing"
    (click)="processUploads()"
  >
    @if (processing) {
    <span class="spinner-border spinner-border-sm me-1"></span>
    } Upload Images
  </button>
</div>